import {  LOADING, NEWS} from "./getter_types";

export default {

    [NEWS]: state => state.newsManagement.news,
    [LOADING]: state => state.loading,
};
